import values from 'lodash/values'

export const routesDef = {
  OverviewPage: {
    name: 'Overview',
    path: '/app/overview',
    exact: true,
    layout: 'main',
  },

  InvoicesPage: {
    name: 'Invoices',
    path: '/app/invoices',
    exact: true,
    layout: 'main',
  },

  ProjectsPage: {
    name: 'Projects',
    path: '/app/projects',
    exact: true,
    layout: 'main',
  },

  CustomersPage: {
    name: 'Companies and Contacts',
    path: '/app/customers',
    exact: true,
    layout: 'main',
  },
  CustomerItemPage: {
    name: 'Customer Item',
    path: '/app/customers/:_id',
    altPath: ({ _id }) => {
      _id = encodeURIComponent(_id)

      return `/app/customers/${_id}`
    },
    exact: true,
    layout: 'main',
  },

  CompanyItemPage: {
    name: 'Company',
    path: '/app/companies/:_id',
    altPath: ({ _id }) => {
      _id = encodeURIComponent(_id)

      return `/app/companies/${_id}`
    },
    exact: true,
    layout: 'main',
  },

  ReportPage: {
    name: 'Reports',
    path: '/app/reports',

    exact: true,
    layout: 'main',
  },

  SettingsPage: {
    name: 'Settings',
    path: '/app/settings',
    exact: true,
    layout: 'main',
  },
  AuthSuccessPage: {
    name: 'Auth Success',
    path: '/auth/success/:auth',
    exact: true,
    layout: 'blank',
  },
  AuthFailedPage: {
    name: 'Auth Failed',
    path: '/auth/failed',
    exact: true,
    layout: 'blank',
  },
  LoginPage: {
    name: 'Login',
    path: '/account/login',
    altPath: '/account/login',
    exact: true,
    layout: 'blank',
  },
  JoinPage: {
    name: 'Join',
    path: '/account/join/',
    exact: true,
    layout: 'blank',
  },
  LoadingPage: {
    name: 'Loading',
    path: '/',
    exact: true,
    layout: 'blank',
  },
  NotificationListPage: {
    name: 'Notification List',
    path: '/app/notifications/list',
    exact: true,
    layout: 'main',
  },
  ChangePasswordPage: {
    name: 'ChangePassword',
    path: '/account/change-password/:username?/:code?',
    altPath: '/account/change-password',
    exact: true,
    layout: 'blank',
  },
  ProfilePage: {
    name: 'Profile',
    path: '/account/profile',
    exact: true,
    layout: 'main',
  },
}

export const routesArray = values(routesDef)
